import {type FC, isValidElement} from 'react';

import type {Props} from './types';

import * as S from './styles';

const DOTS = '.'.repeat(1000);

export const IndexRow: FC<Props> = ({
  color = 'text3',
  keyColor,
  size = 'me',
  testID,
  title,
  value,
  valueColor,
  variant,
  ...rest
}) => {
  return (
    <S.Container testID={testID} {...rest}>
      <S.Key color={keyColor ?? color} size={size}>
        {title}
      </S.Key>
      <S.DotsLine size={size}>{DOTS}</S.DotsLine>
      {isValidElement(value) ? (
        value
      ) : (
        <S.Value
          color={valueColor ?? color}
          size={size}
          weight={variant ? 'bold' : 'regular'}
        >
          {value}
        </S.Value>
      )}
    </S.Container>
  );
};
